import React, { Component }  from 'react';
import {Button} from "@mui/material";
import "./ButtonsStyleSheet.css"
import PropTypes from "prop-types";

const ButtonSecondaryRaiko = ({className, onClick, label}) => {
    return (
        <Button
            id="SecondaryButton"
            className={className}
            onClick={onClick}
        >
            <span>{label}</span>
        </Button>
    )
}

export default ButtonSecondaryRaiko;

ButtonSecondaryRaiko.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className:PropTypes.string
}